import React, { useState, useEffect } from "react";
import { Stack, Button, Card } from "react-bootstrap";
import StatusTag from "../../../components/Common/StatusTag";
import { STATUS_MAP } from "../../../utils/constant";
import { getAgreementsRequest } from "@/services";
import { useModalQueryParams } from "@/utils/useModalQueryParams";

import "../dashboard_styles.css";

import AgreementListModal from "../../../components/Modal/application/agreement_list_modal";
import { useParams } from "react-router-dom";
import { computeRequiredAgreementsStatus } from "../utils";

function AgreementSign({ loanId, refreshStatus, onStepStatusChange }) {
  const { applicationId } = useParams();
  const [agreementsLoading, setAgreementsLoading] = useState(false);
  const [agreementDetails, setAgreementDetails] = useState({});
  const [showListModal, setShowListModal] = useModalQueryParams('agreement', false);

  const { status } = agreementDetails || {};
  const stepComplete = status === "signed";

  useEffect(() => {
    if (onStepStatusChange) {
      onStepStatusChange(stepComplete);
    }
  }, [stepComplete]);

  let description = "";
  let disableCard = true;

  if (!!status) {
    if (status === "signed" || status == "verified") {
      description = "All agreements have been signed. Click view and download your signed documents.";;
      disableCard = false;
    }
    else if (status == "partial") {
      description = "Please wait for all documents to be signed offline. You may still view and download the signed ones.";
      disableCard = false;
    }
    else {
      description = "Please wait for all signed documents to be uploaded";
      disableCard = true;
    }
  }

  useEffect(() => {
    fetchAgreement();
  }, [loanId]);

  const fetchAgreement = async () => {
    if (!loanId) return;
    setAgreementsLoading(true);
    try {
      const resp = await getAgreementsRequest({ loan_id: applicationId });
      if (resp?.status) {
        const overallStatus = computeRequiredAgreementsStatus(resp.results || []);
        setAgreementDetails({ status: overallStatus });
      }
    } catch (err) {
      console.error("Error fetching agreement details:", err);
    } finally {
      setAgreementsLoading(false);
    }
  };

  const openAgreementsModal = () => {
    setShowListModal(true);
  };

  return (
    <Card className={`dashboardActionCard ${disableCard ? "disabledCard" : "activeCard"}`}>
      <Stack direction="horizontal" gap={3}>
        <Stack gap={2} className="actionContent">
          <h4 className="actionCardTitle dash_statusDiv">
            View Signed Documents
            {!agreementsLoading && status && (
              <StatusTag
                status={status}
                stepComplete={stepComplete}
                label={STATUS_MAP[status]?.label || "Unknown"}
              />
            )}
          </h4>
          {!agreementsLoading && <p className="actionCardDescription">{description}</p>}
        </Stack>

        <div>
          <Button
            variant="primary"
            onClick={openAgreementsModal}
            disabled={!agreementDetails}
            className="actionButton"
          >
            View
          </Button>
        </div>
      </Stack>

      {showListModal && (
        <AgreementListModal
          show={showListModal}
          onHide={() => setShowListModal(false)}
          loanId={loanId}
          refreshStatus={refreshStatus}
        />
      )}
    </Card>
  );
}

export default AgreementSign;